import styled, { css } from 'styled-components';

export const ContactSection = styled.section`
  height: 100%;
  overflow: hidden;
  width: 100%;
  will-change: contents;
  min-height: 566px;
  z-index: 1;
  transform-style: preserve-3d;
  animation: fadeIn 1s forwards;
  animation-delay: 2.5s;
  opacity: 0;

  h1 {
    font-size: 43px;
    color: #3bcfe3;
    font-weight: 400;
    font-family: 'Lato', sans-serif;
    margin-top: 0;
    position: relative;
    margin-bottom: 30px;
    left: -10px;

    &:before {
      content: '<h1>';
      font-family: 'La Belle Aurore', cursive;
      color: #3bcfe3;
      font-size: 18px;
      position: absolute;
      margin-top: -10px;
      left: -10px;
      opacity: 0.3;
      line-height: 18px;
    }

    &:after {
      content: '<h1/>';
      font-family: 'La Belle Aurore', cursive;
      color: #3bcfe3;
      font-size: 18px;
      line-height: 18px;
      position: absolute;
      left: -30px;
      bottom: -20px;
      margin-left: 20px;
      opacity: 0.3;
    }
  }

  p {
    color: #d6d6d6;
    font-size: clamp(1rem, 2.5vw, 1.2rem);
    line-height: 26px;
    letter-spacing: 0.05rem;
    word-spacing: 0.15rem;
    max-width: fit-content;
  }

  .text-zone {
    max-height: 90%;
    padding: 4rem;

    .trans-text {
      transform: translateY(60%);
      opacity: 0;
      -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
      transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
      ${({ isVisible }) =>
        isVisible &&
        css`
          -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
          transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
          transform: translate(0%, 0%);
          opacity: 1;
        `}
    }

    p {
      max-width: 32rem;
      width: 100%;
    }
    
    @media (max-width: 588px) {
      padding: 2rem;
    }
    @media (max-width: 360px) {
      padding: 1.2rem;
    }
    @media (max-width: 330px) {
      padding: 5rem 1.3rem;
    }
  }

  .grid-2 {
    display: flex;
    grid-gap: 3rem;
    align-items: center;
    justify-content: center;
    @media (max-width: 766px) {
      flex-direction: column-reverse;
      grid-gap: 0;
    }
  }

  .contact-img {
    width: 50%;
    height: 26rem;
    filter: invert(100%) sepia(100%) saturate(2%) hue-rotate(265deg)
      brightness(105%) contrast(100%);
    opacity: 0.15;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 75%;
      height: 75%;
      margin-top: -5rem;
      @media (max-width: 766px) {
        width: 100%;
        height: 100%;
      }
    }
    @media (max-width: 766px) {
      width: 100%;
      margin-bottom: -24rem;
    }
  }

  .contact-form {
    width: 50%;
    margin-top: 20px;
    z-index: 2;
    opacity: 0;
    transform: translateY(30%);
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);

    @media (max-width: 766px) {
      max-width: 30rem;
      width: 100%;
    }

    ul {
      padding: 0;
      margin: 0;

      li {
        padding: 0;
        margin: 0;
        list-style: none;
        margin-bottom: 10px;
        opacity: 0;
        overflow: hidden;
        display: block;
        clear: both;
        position: relative;
        animation: fadeInUp 2s 2s;
        animation-fill-mode: forwards;
      }

      li.half {
        width: 49%;
        margin-left: 2%;
        float: left;
        clear: none;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    input[type='text'],
    input[type='email'] {
      width: 100%;
      border: 0;
      background: #115173;
      height: 50px;
      font-size: 0.8rem;
      color: #fff;
      padding: 0 17px;
      box-sizing: border-box;
    }

    textarea {
      width: 100%;
      border: 0;
      background: #115173;
      height: 40px;
      font-size: 0.8rem;
      color: #fff;
      padding: 20px;
      box-sizing: border-box;
      min-height: 150px;
    }

    .flat-button {
      color: #3bcfe3;
      font-size: 11px;
      letter-spacing: 3px;
      text-decoration: none;
      padding: 8px 10px;
      border: 1px solid #3bcfe3;
      float: left;
      border-radius: 4px;
      background: 0 0;
      text-transform: uppercase;
      float: right;
      text-align: center;
      margin-right: 10px;
    }
    ${({ isInView }) =>
      isInView &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
        opacity: 1;
      `}
  }
`;
